import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LibraryProvider } from './context/LibraryContext';
import { ReportProvider } from './context/ReportContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Library from './pages/Library';
import PolicyChecker from './pages/PolicyChecker';
import Search from './pages/Search';
import AskMeAnything from './pages/AskMeAnything';
import ReportBug from './pages/ReportBug';
import Help from './pages/Help';
import LogoutBridge from './pages/LogoutBridge';
import './App.css';

// /logout-bridge must render outside AuthProvider: sibling products load it in a
// hidden iframe, and AuthProvider's bootstrap effect calling getCurrentSession()
// there races and clobbers the bridge's own revoke call (mirrors platform-web's
// client-providers.tsx fix for the same issue).
export function AppRoutes() {
  const location = useLocation();
  if (location.pathname === '/logout-bridge') return <LogoutBridge />;

  return (
    <AuthProvider>
      <LibraryProvider>
        <ReportProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/policy-checker" replace />} />
              <Route path="library" element={<Library />} />
              <Route path="policy-checker" element={<PolicyChecker />} />
              <Route path="search" element={<Search />} />
              <Route path="ask-me-anything" element={<AskMeAnything />} />
              <Route path="report-bug" element={<ReportBug />} />
              <Route path="help/*" element={<Help />} />
            </Route>
          </Routes>
        </ReportProvider>
      </LibraryProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
